/**
 * MessageInputHook - Auto-resizing textarea with Enter-to-submit
 *
 * Features:
 * - Auto-expands/shrinks as user types (up to max-height)
 * - Enter key submits the form
 * - Shift+Enter creates a new line
 * - Resets height on submit
 */
const MessageInputHook = {
  mounted() {
    this.setupAutosize();
    this.setupKeyboardHandling();
  },

  updated() {
    // Reset size when message is cleared (after sending)
    if (this.el.value === '') {
      this.el.style.height = 'auto';
    } else {
      this.autosize();
    }
  },

  setupAutosize() {
    this.el.style.boxSizing = "border-box";
    this.offset = this.el.offsetHeight - this.el.clientHeight || 0;

    this.el.addEventListener("input", () => this.autosize());
    this.autosize();
  },

  autosize() {
    this.el.style.height = "auto";
    const maxHeight = parseInt(getComputedStyle(this.el).maxHeight) || 120;
    const newHeight = Math.min(this.el.scrollHeight + this.offset, maxHeight);
    this.el.style.height = newHeight + "px";
  },

  setupKeyboardHandling() {
    this.el.addEventListener("keydown", (e) => {
      // Enter without Shift submits the form
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();

        // Don't submit if empty
        if (this.el.value.trim() === '') {
          return;
        }

        // Find and submit the parent form
        const form = this.el.closest("form");
        if (form) {
          // Trigger the form submit event
          form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        }
      }
    });
  }
};

export default MessageInputHook;
